import { render, staticRenderFns } from "./PreviousTreatmentNode.vue?vue&type=template&id=1678e0f9&scoped=true&"
import script from "./PreviousTreatmentNode.vue?vue&type=script&lang=js&"
export * from "./PreviousTreatmentNode.vue?vue&type=script&lang=js&"
import style0 from "./PreviousTreatmentNode.vue?vue&type=style&index=0&id=1678e0f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678e0f9",
  null
  
)

export default component.exports